<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Programs</h2>
        </span>

        <span class="d-flex align-items-center gap-3">
          <a for="test"> Show Clients </a>
          <label class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radiobutton
              inputId="Open"
              name="radio"
              value="1"
              (click)="showOrHideClientColumn(true)" />
            <span class="link mx-2">Yes</span>
          </label>
          <label class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radiobutton
              inputId="Open"
              name="radio"
              value="2"
              (click)="showOrHideClientColumn(false)" />
            <span class="link mx-2">No</span>
          </label>
          <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
            <jni-spinner></jni-spinner>
          </div>
          <p-button
            label="Add"
            (click)="onAddProgramRedirection()"
            [icon]="'pi pi-plus'" />

          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />
        </span>
      </span>
      <div class="col-lg-12 adduser-container-hgt p-3">
        <p-table
          #dt
          stripedRows
          [size]="'small'"
          [value]="filteredProgramListing"
          [(selection)]="selectedProgramListing"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [rows]="50"
          scrollHeight="450px"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          (onFilter)="onFilter($event)"
          styleClass="table-listing popuptable">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="number" pSortableColumn="name">
                Program <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th class="bc">BC</th>
              <th
                class="number"
                *ngIf="showClientData"
                pSortableColumn="clientName">
                Client Name <p-sortIcon field="clientName"></p-sortIcon>
              </th>
              <th class="number" *ngIf="showClientData">Client#</th>
              <th class="date-time" *ngIf="showClientData">Client Added</th>
              <th class="status" pSortableColumn="programStatus">
                Status <p-sortIcon field="programStatus"></p-sortIcon>
              </th>
              <th class="notes">D365-DIM</th>

              <th class="notes" *ngIf="showClientData">DFLT-DIm</th>

              <th class="date-time" *ngIf="!showClientData">Date Added</th>
              <th>Nadel Inv</th>
              <th>Website</th>
              <th>Warehouse</th>
              <th>Microsite</th>
              <th>Client Inv</th>
              <th>Intl</th>
              <th>CC</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="name"
                    id="name"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'name', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>

              <th></th>
              <th *ngIf="showClientData">
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="clientName"
                    id="clientName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>

              <th *ngIf="showClientData">
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="clientId"
                    id="clientId"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientId',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>

              <th *ngIf="showClientData"></th>
              <th></th>
              <th class="notes"></th>

              <th *ngIf="showClientData"></th>

              <th *ngIf="!showClientData"></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-programListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="programListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="number">
                <a class="link" (click)="redirectToSummary(programListing.id)">
                  {{ programListing.name }}</a
                >
              </td>
              <td>
                <span *ngIf="programListing.brandingConsultantNameD365">
                  {{ programListing.brandingConsultantD365 }}:
                  {{ programListing.brandingConsultantNameD365 }}
                </span>
              </td>
              <td class="notes" *ngIf="showClientData">
                {{ programListing.clientName }}
              </td>
              <td class="number" *ngIf="showClientData">
                {{ programListing.clientId }}
              </td>

              <td class="date-time" *ngIf="showClientData">
                {{ programListing.clientAdded | date: "MM-dd-yyyy" }}
              </td>

              <td class="status">{{ programListing.programStatus }}</td>
              <td class="notes">{{ programListing.dimensionD365 }}</td>

              <td class="number" *ngIf="showClientData">
                {{ programListing.defaultClient === true ? "Yes" : "No" }}
              </td>

              <td class="date-time" *ngIf="!showClientData">
                {{ programListing.dateAdded | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ programListing.nadelOwnInv ? "Yes" : "No" }}
              </td>
              <td>
                {{ programListing.usesWebsite ? "Yes" : "No" }}
              </td>
              <td>
                {{ programListing.uses3PL ? "Yes" : "No" }}
              </td>
              <td>
                {{ programListing.micro ? "Yes" : "No" }}
              </td>
              <td>
                {{ programListing.clientOwnInv ? "Yes" : "No" }}
              </td>
              <td>
                {{ programListing.intl ? "Yes" : "No" }}
              </td>
              <td>
                {{ programListing.inStoreCC ? "Yes" : "No" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No Programs found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders py-4">
  <header class="orders-header has-border align-items-center d-flex pb-2 mb-4">
    <h1 class="m-0">Programs</h1>
    <div class="prospects-panel d-flex justify-content-between ms-2 me-auto">
      <label
        class="ms-2 nav-link p-0 d-flex align-items-center"
        style="margin-right: 30px"
        for="test">
        Show Clients
      </label>
      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radiobutton
          id="Open"
          type="radio"
          class="me-2"
          name="radio"
          (onClick)="showOrHideClientColumn(true)" />
        <span class="link">Yes</span>
      </label>
      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radiobutton
          id="Open"
          type="radio"
          class="me-2"
          name="radio"
          checked="true"
          (onClick)="showOrHideClientColumn(false)" />
        <span class="link">No</span>
      </label>
      <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
        <jni-spinner></jni-spinner>
      </div>
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <a class="link" (click)="onAddProgramRedirection()">
          <i class="icon-Add me-2"></i>Add</a
        >
      </div>
    </div>

    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </header>
  <p-table
    #dt
    [value]="filteredProgramListing"
    [(selection)]="selectedProgramListing"
    styleClass="p-datatable-customers ordersListing search-more"
    [rowHover]="true"
    [rows]="20"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="true"
    [filterDelay]="0"
    (onFilter)="onFilter($event)">
    <ng-template pTemplate="header">
      <tr>
        <th class="number" pSortableColumn="name">
          Program <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th class="bc">BC</th>
        <th class="number" *ngIf="showClientData" pSortableColumn="clientName">
          Client Name <p-sortIcon field="clientName"></p-sortIcon>
        </th>
        <th class="number" *ngIf="showClientData">Client#</th>
        <th class="date-time" *ngIf="showClientData">Client Added</th>
        <th class="status" pSortableColumn="programStatus">
          Status <p-sortIcon field="programStatus"></p-sortIcon>
        </th>
        <th class="notes">D365-DIM</th>

        <th class="notes" *ngIf="showClientData">DFLT-DIm</th>

        <th class="date-time" *ngIf="!showClientData">Date Added</th>
        <th>Nadel Inv</th>
        <th>Website</th>
        <th>Warehouse</th>
        <th>Microsite</th>
        <th>Client Inv</th>
        <th>Intl</th>
        <th>CC</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="name"
              id="name"
              style="max-width: 200px"
              (input)="dt.filter($any($event.target).value, 'name', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>

        <th></th>
        <th *ngIf="showClientData">
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="clientName"
              id="clientName"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'clientName', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>

        <th *ngIf="showClientData">
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="clientId"
              id="clientId"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'clientId', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>

        <th *ngIf="showClientData"></th>
        <th></th>
        <th class="notes"></th>

        <th *ngIf="showClientData"></th>

        <th *ngIf="!showClientData"></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-programListing let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="programListing"
        [pSelectableRowIndex]="rowIndex">
        <td class="number">
          <a class="link" (click)="redirectToSummary(programListing.id)">
            {{ programListing.name }}</a
          >
        </td>
        <td>
          <span *ngIf="programListing.brandingConsultantNameD365">
            {{ programListing.brandingConsultantD365 }}:
            {{ programListing.brandingConsultantNameD365 }}
          </span>
        </td>
        <td class="notes" *ngIf="showClientData">
          {{ programListing.clientName }}
        </td>
        <td class="number" *ngIf="showClientData">
          {{ programListing.clientId }}
        </td>

        <td class="date-time" *ngIf="showClientData">
          {{ programListing.clientAdded | date: "MM-dd-yyyy" }}
        </td>

        <td class="status">{{ programListing.programStatus }}</td>
        <td class="notes">{{ programListing.dimensionD365 }}</td>

        <td class="number" *ngIf="showClientData">
          {{ programListing.defaultClient === true ? "Yes" : "No" }}
        </td>

        <td class="date-time" *ngIf="!showClientData">
          {{ programListing.dateAdded | date: "MM-dd-yyyy" }}
        </td>
        <td>
          {{ programListing.nadelOwnInv ? "Yes" : "No" }}
        </td>
        <td>
          {{ programListing.usesWebsite ? "Yes" : "No" }}
        </td>
        <td>
          {{ programListing.uses3PL ? "Yes" : "No" }}
        </td>
        <td>
          {{ programListing.micro ? "Yes" : "No" }}
        </td>
        <td>
          {{ programListing.clientOwnInv ? "Yes" : "No" }}
        </td>
        <td>
          {{ programListing.intl ? "Yes" : "No" }}
        </td>
        <td>
          {{ programListing.inStoreCC ? "Yes" : "No" }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No Programs found.</td>
      </tr>
    </ng-template>
  </p-table>
</div> -->

<jni-modal-stacker
  *ngIf="programDisplayModel"
  [displayModal]="programDisplayModel"
  (closeEvent)="closeModalForProgram()"
  class="modal-header-sticky">
  <h1 class="panelHeading">Program Summary</h1>
  <div class="panelBody">
    <jni-program-summary
      [programId]="programId"
      (closeModalEvent)="closeModalForProgram()"></jni-program-summary>
  </div>
</jni-modal-stacker>
